import { render, staticRenderFns } from "./RepseDocumentationTable.vue?vue&type=template&id=567d860b"
import script from "./RepseDocumentationTable.vue?vue&type=script&lang=js"
export * from "./RepseDocumentationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports